import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
export default class SegmentAnalytics {
  constructor(_ref) {
    let {
      analytics,
      timeout = 3000
    } = _ref;
    this.analytics = analytics;
    this.timeout = timeout;
  }

  reportSignUp(_ref2) {
    let {
      analyticsProperties
    } = _ref2;
    const {
      memberProperties,
      accountCreateProperties
    } = analyticsProperties;
    const trackEventData = {
      platform: 'web',
      ...accountCreateProperties
    };
    return new _Promise((resolve, reject) => {
      _setTimeout(reject, this.timeout, new Error('Segment timed out.'));

      this.analytics.alias(memberProperties.userId, memberProperties, () => {
        const identifyData = { ...memberProperties,
          unreadMessages: 0
        };
        this.analytics.identify(memberProperties.userId, identifyData, () => {
          this.analytics.track('New Registration', trackEventData, resolve);
        });
      });
    });
  }

  reportLogIn(_ref3) {
    let {
      analyticsProperties
    } = _ref3;
    const {
      memberProperties,
      accountCreateProperties
    } = analyticsProperties;
    const trackEventData = {
      platform: 'web',
      ...accountCreateProperties
    };
    return new _Promise((resolve, reject) => {
      _setTimeout(reject, this.timeout, new Error('Segment timed out.'));

      this.analytics.identify(memberProperties.userId, memberProperties, () => {
        this.analytics.track('Log In', trackEventData, resolve);
      });
    });
  }

  reset() {
    return this.analytics.reset();
  }

}